import React from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Phone, List, X } from "@phosphor-icons/react";
import { BUSINESS } from "@/data/site";

const navItems = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/shop", label: "Shop" },
  { to: "/estimate", label: "Estimate" },
  { to: "/reviews", label: "Reviews" },
  { to: "/about", label: "About" },
  { to: "/careers", label: "Careers" },
  { to: "/contact", label: "Contact" },
];

export const Header = () => {
  const [open, setOpen] = React.useState(false);
  const location = useLocation();

  React.useEffect(() => { setOpen(false); }, [location.pathname]);

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 border-b border-[var(--ji-border)]/70 backdrop-blur-xl"
      style={{ background: "rgba(253, 251, 247, 0.82)" }}
    >
      <div className="ji-container flex items-center justify-between h-16 md:h-20 gap-4">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-3 group shrink-0">
          <span
            className="inline-flex items-center justify-center w-9 h-9 text-white font-bold"
            style={{ background: "var(--ji-primary)", borderRadius: 4, fontFamily: "Cabinet Grotesk" }}
          >JI</span>
          <span className="flex flex-col leading-none">
            <span style={{ fontFamily: "Cabinet Grotesk" }} className="text-lg font-bold tracking-tight text-[var(--ji-text)]">
              Joseph Industries
            </span>
            <span className="text-[10px] uppercase tracking-[0.22em] text-[var(--ji-muted)] mt-1">
              Appliances · Courier · Home
            </span>
          </span>
        </Link>

        <nav className="hidden xl:flex items-center gap-6" data-testid="desktop-nav">
          {navItems.map((it) => (
            <NavLink
              key={it.to}
              to={it.to}
              end={it.to === "/"}
              data-testid={`nav-${it.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `text-sm font-medium tracking-tight transition-colors ${
                  isActive ? "text-[var(--ji-primary)]" : "text-[var(--ji-text)] hover:text-[var(--ji-accent)]"
                }`
              }
            >
              {it.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden xl:flex items-center gap-2 shrink-0">
          <Link
            to="/contact"
            data-testid="header-quote-cta"
            className="ji-btn-accent inline-flex items-center gap-2 px-4 h-10 text-sm font-semibold"
            style={{ borderRadius: 4 }}
          >
            Free Quote
          </Link>
          <a
            href={`tel:${BUSINESS.phones[0].tel}`}
            data-testid="header-phone-cta"
            className="ji-btn-primary inline-flex items-center gap-2 px-4 h-10 text-sm font-semibold"
            style={{ borderRadius: 4 }}
          >
            <Phone size={16} weight="bold" />
            {BUSINESS.phones[0].display}
          </a>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          aria-label="Toggle menu"
          onClick={() => setOpen((v) => !v)}
          className="xl:hidden inline-flex items-center justify-center w-10 h-10 border border-[var(--ji-border)]"
          style={{ borderRadius: 4 }}
        >
          {open ? <X size={20} /> : <List size={20} />}
        </button>
      </div>

      {open && (
        <div className="xl:hidden border-t border-[var(--ji-border)] bg-[var(--ji-bg)]" data-testid="mobile-nav">
          <div className="ji-container py-4 flex flex-col gap-1">
            {navItems.map((it) => (
              <NavLink
                key={it.to}
                to={it.to}
                end={it.to === "/"}
                data-testid={`mobile-nav-${it.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={({ isActive }) =>
                  `py-3 px-2 text-base font-medium border-l-2 ${
                    isActive ? "border-[var(--ji-accent)] text-[var(--ji-primary)]" : "border-transparent text-[var(--ji-text)]"
                  }`
                }
              >
                {it.label}
              </NavLink>
            ))}
            <Link
              to="/contact"
              data-testid="mobile-header-quote-cta"
              className="ji-btn-accent mt-3 inline-flex items-center justify-center gap-2 px-4 h-12 text-sm font-semibold"
              style={{ borderRadius: 4 }}
            >
              Request a Free Quote
            </Link>
            <a
              href={`tel:${BUSINESS.phones[0].tel}`}
              data-testid="mobile-header-phone-cta"
              className="ji-btn-primary mt-2 inline-flex items-center justify-center gap-2 px-4 h-12 text-sm font-semibold"
              style={{ borderRadius: 4 }}
            >
              <Phone size={16} weight="bold" />
              Call {BUSINESS.phones[0].display}
            </a>
          </div>
        </div>
      )}
    </header>
  );
};
